<template>
  <div class="form-group-wrap__btn-wrap">
    <button
      class="c-btn--full c-btn--narrow"
      type="button"
      @click="$emit('toggle', belongsTo)">
      <span class="mdi mdi-plus-box icon-style"></span>
      {{ buttonText }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'CopyrightAccordion',
  props: {
    buttonText: {
      type: String,
      required: true,
    },
    belongsTo: {
      type: String,
      required: true,
    },
  },
}
</script>
<style scoped>
.c-btn--full {
  width: 100% !important;
  border-radius: 50px;
}

.c-btn--full:hover {
 background-color:  #e3e3e3;
}

@media screen and (min-width: 896px) {
  .c-btn--narrow {
    min-width: inherit;
    padding: 11px 60px;
    text-align: left;
  }
}

@media screen and (max-width: 895px) {
  .c-btn--narrow {
    font-size: 3.73333vw;
    padding: 1.33333vw 0vw;
    width: 100%;
  }
}
</style>
